import { ASYNC_START, ASYNC_STOP } from 'ActionTypes/async';

const initialState = {
  curp: false,
  postal_code: false,
  subIndustry: {
    isLoading: false,
    options: [],
  },
  subOccupation: {
    isLoading: false,
    options: [],
    requiresIndustry: false,
  },
};

export const asyncField = (state = initialState, action) => {
  switch (action.type) {
    case ASYNC_START:
      return {
        ...state,
        ...action.payload,
      };
    case ASYNC_STOP:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};

export default asyncField;
